import { render, staticRenderFns } from "./LevelIndocator.vue?vue&type=template&id=084cb205"
import script from "./LevelIndocator.vue?vue&type=script&lang=js"
export * from "./LevelIndocator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports